// src/App.js
import { Outlet, useLocation } from "react-router-dom";
import React, { useEffect, Suspense } from 'react';
import { DevelopmentToolbar } from './components/DevelopmentToolbar';
import loadable from '@loadable/component';
import { trackMainWebsitePageview } from './utils/tracking/googleAds';
import { trackMainWebsitePageview as trackTikTokMainWebsitePageview } from './utils/tracking/tiktokPixel';

// Import the lazy-loaded components you want to preload
const Dashboard = loadable(() => import('./pages/Dashboard'));
const MyStore = loadable(() => import('./pages/MyStore'));
const Products = loadable(() => import('./pages/MyStore/components/Products'));
const Store = loadable(() => import('./pages/MyStore/components/Shop'));

function App() {
    const location = useLocation();
    
    useEffect(() => {
        // Preload important components
        const preloadComponents = async () => {
            try {
                await Promise.all([
                    Dashboard.load(),
                    MyStore.load(),
                    Products.load(),
                    Store.load()
                ]);
                console.log('Components preloaded successfully');
            } catch (error) {
                console.error('Error preloading components:', error);
            }
        };

        preloadComponents();
    }, []);
    
    useEffect(() => {
        // In a browser, check the host to determine if we're on a creator store
        if (window.location.hostname === 'sparkle.store') {
            // For creator stores with format: sparkle.store/username
            // If the path only has a username (single segment), it's a creator store
            const pathSegments = location.pathname.split('/').filter(Boolean);
            if (pathSegments.length === 1) {
                // This is likely a creator store URL like sparkle.store/username
                return;  // Don't track creator stores
            }
        }
        // Track all main website pages, including the homepage
        trackMainWebsitePageview();
        trackTikTokMainWebsitePageview();
    }, [location]);

    return (
        <>
            <DevelopmentToolbar />
            <Suspense fallback={<div>Loading...</div>}>
                <Outlet />
            </Suspense>
        </>
    );
}

export default App;
